// extracted by mini-css-extract-plugin
export default {"Panel":"Panel--ilB61","PanelTitle":"PanelTitle--GGzZG","BlockedReport":"BlockedReport--pTYtj"};